module.exports = __webpack_public_path__ + "fonts/7227c0d.ttf";